import { render, staticRenderFns } from "./SalesStep.vue?vue&type=template&id=995a0058&scoped=true"
import script from "./SalesStep.vue?vue&type=script&lang=js"
export * from "./SalesStep.vue?vue&type=script&lang=js"
import style0 from "./SalesStep.vue?vue&type=style&index=0&id=995a0058&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "995a0058",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/ap-cn-sfe-fe-pc/ap-cn-sfe-fe-pc/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('995a0058')) {
      api.createRecord('995a0058', component.options)
    } else {
      api.reload('995a0058', component.options)
    }
    module.hot.accept("./SalesStep.vue?vue&type=template&id=995a0058&scoped=true", function () {
      api.rerender('995a0058', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/sfe/storeVisitReport/components/Step/SalesStep.vue"
export default component.exports